import { render, staticRenderFns } from "./ActivationEmail.vue?vue&type=template&id=3d80bad2&scoped=true&"
import script from "./ActivationEmail.vue?vue&type=script&lang=ts&"
export * from "./ActivationEmail.vue?vue&type=script&lang=ts&"
import style0 from "./ActivationEmail.vue?vue&type=style&index=0&id=3d80bad2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d80bad2",
  null
  
)

export default component.exports